export const ECLIPS_KEY_METADATA = 'eclips-metadata'
export type EclipsMetadata = {
	inclusion: boolean
	username: string
	location: string
	organization: string
}
